module.exports = __webpack_public_path__ + "img/thumb_08.bf2cafa0.jpg";